export default {"src":"/_next/static/media/trashbin_24.e0d68a73.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};